import * as React from "react";

export interface IPartialLoadContext {
    registerElement(objectRef: React.RefObject<HTMLDivElement | null>, handler: (next: boolean) => void): boolean;
}

export const PartialLoadContextObject = React.createContext<IPartialLoadContext | undefined>(undefined);

export interface FirstRenderContext {
    firstRenderCompleted: boolean;
    /***
     * Ужасающий мега хак, чтобы первые элементы были отрисованы без доп. вызовов рендера
     */
    renderedAtFirstCount: number;
}

export const PartialRenderFirstRenderContextObject = React.createContext<FirstRenderContext>({
    firstRenderCompleted: true,
    renderedAtFirstCount: 0,
});

export function usePartialRender(): [loaded: boolean, ref: React.RefCallback<HTMLDivElement | null>] {
    const firstRenderContext = React.useContext(PartialRenderFirstRenderContextObject);
    const [loaded, setLoaded] = React.useState(() => {
        if (firstRenderContext.firstRenderCompleted) {
            return true;
        }
        firstRenderContext.renderedAtFirstCount--;
        return firstRenderContext.renderedAtFirstCount > 0;
    });

    const rootRef = React.useRef<HTMLDivElement | null>(null);
    const handlerRef = React.useRef<{} | null>();

    React.useEffect(() => {
        handlerRef.current = {
            changeStateHandler: (nextState: boolean) => setLoaded(nextState),
        };
    }, []);

    const refCallback = React.useCallback((nextElement: HTMLDivElement | null) => {
        const prevElement = rootRef.current;
        if (prevElement) {
            // @ts-ignore
            delete prevElement["__candyPartialLoadHandler"];
        }
        if (nextElement) {
            // @ts-ignore
            nextElement["__candyPartialLoadHandler"] = handlerRef;
            rootRef.current = nextElement;
        }
    }, []);

    return [loaded, refCallback];
}
